import script from "./ProductsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductsPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProductsPage.vue?vue&type=style&index=0&id=29395a7f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29395a7f"]])

export default __exports__